/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { FC, useMemo } from "react";

import { useI18n, I18nChildContext } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import { Icon, Text } from "@bookingcom/bui-react";
import { UIAvailableExtraProducts, UIIncludedProductBySegmentCompressed } from "@flights/types";
import { arrayUtils } from "@flights/web-api-utils-universal";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import Frame from "../../../../components/elements/Frame";
import styles from "./InconsistentCabinBaggageInfo.module.css";

export const InconsistentCabinBaggageInfo: FC<{
  includedProducts: UIIncludedProductBySegmentCompressed;
  ancillaries: UIAvailableExtraProducts;
}> = ({ includedProducts, ancillaries }) => {
  const i18n = useI18n() as I18nChildContext;

  const isIncludedCabinBaggageInconsistentBetweenSegments = useMemo(() => {
    const cabinBaggageBySegment: boolean[] = includedProducts.segments.map((segment) => {
      return segment.some((item) => item.luggageType === "HAND");
    });

    return !arrayUtils.isConsistent(cabinBaggageBySegment);
  }, [includedProducts]);

  const isCabinBaggageAvailableAsExtra = ancillaries.cabinBaggage;

  const shouldShow = isIncludedCabinBaggageInconsistentBetweenSegments && isCabinBaggageAvailableAsExtra;

  if (shouldShow) {
    return (
      <Frame direction="row" className={styles.root}>
        <div>
          <Icon svg={InfoSignIcon} size="larger" color="accent" />
        </div>
        <div className={styles.text}>
          <Text variant="emphasized_2">{i18n.trans(t("flights_cabin_bag_bound"))}</Text>
        </div>
      </Frame>
    );
  } else {
    return null;
  }
};
